module.exports = __webpack_public_path__ + "img/rope-sealant-joint-repair.b184b78d.jpg";